import { render, staticRenderFns } from "./ProcedureModelNew.vue?vue&type=template&id=1dcc06d2&"
import script from "./ProcedureModelNew.vue?vue&type=script&lang=js&"
export * from "./ProcedureModelNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports